.item {
  padding: var(--ns-space-1) var(--ns-space-2);
  color: inherit;
  text-decoration: none;
  border-radius: var(--ns-border-radius-3);
  transition: background-color 0.2s ease;
  cursor: pointer;
}

.item:focus,
.item:hover {
  background-color: var(--ns-color-focus);
}
